import type { HelpFile } from '../../types/help'
import { ProvisioningDashboardTestIds } from '../../../testids/ProvisioningDashboardTestIds'

export const provisioningDashboardHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-history',
  texts: {
    [ProvisioningDashboardTestIds.provisioningDashboardPage]: 'Provisioning task activity — queued, running, completed, and failed counts, with actions to drive the queue.',
    [ProvisioningDashboardTestIds.btnArchiveCompleted]: 'Archive completed Provisioning Tasks to keep the active queue lean.',
    [ProvisioningDashboardTestIds.btnProcessAll]: 'Run all queued Provisioning Tasks immediately — bypasses the scheduled window.',
    [ProvisioningDashboardTestIds.btnRequeueReady]: 'Re-enqueue tasks that are ready but stuck, so they are picked up by the next worker cycle.',
    [ProvisioningDashboardTestIds.cardTitleAboutProvisioningTasks]: null,
    [ProvisioningDashboardTestIds.cardTitleStat]: null,
    [ProvisioningDashboardTestIds.statQueued]: 'Provisioning Tasks queued and waiting for execution.',
    [ProvisioningDashboardTestIds.statRunning]: 'Provisioning Tasks currently in progress.',
    [ProvisioningDashboardTestIds.statCompleted]: 'Provisioning Tasks that completed successfully.',
    [ProvisioningDashboardTestIds.statFailed]: 'Provisioning Tasks that encountered an error during execution.',
  },
}
